<span>Сила<mat-slide-toggle [(ngModel)]="isElevation"> 
    
</mat-slide-toggle>Подъем</span> <br/>
<div>

<app-point  id="TELEPAD" [(cords)]="Telepad" [x_label]="'X Телепада'" [y_label]="'Y Телепада'"    ></app-point> <br>
<app-point [(cords)]="Start" [x_label]="'X1:'" [y_label]="'Y1:'"  ></app-point> <br/>
<app-point [(cords)]="End" [x_label]="'X2:'" [y_label]="'Y2:'"></app-point>   
</div>
<div >
  <ng-template [ngIf]="isElevation" [ngIfElse]="power">
  
   <label>Подъем 1
       <input type="number" [(ngModel)]="Elevation1" /> 
   </label>
   <label>Подъем 2
    <input type="number" [(ngModel)]="Elevation2" /> 
    </label>

  </ng-template>
  <ng-template #power>
    <label>Сила 1 <select [(ngModel)]="Power1">
     <option value="5">5</option>
     <option value="10">10</option>
     <option value="20">20</option>
     <option value="25">25</option>
     <option value="30">30</option>
     <option value="40">40</option>
     <option value="50">50</option>
     <option value="80">80</option>
     <option value="100">100</option>
    </select>
    </label>
    <label>Сила 2 <select [(ngModel)]="Power2">
      <option value="5">5</option>
      <option value="10">10</option>
      <option value="20">20</option>
      <option value="25">25</option>
      <option value="30">30</option>
      <option value="40">40</option>
      <option value="50">50</option>
      <option value="80">80</option>
      <option value="100">100</option>
     </select>
     </label>
  </ng-template>
</div>


<label *ngIf="isElevation">СИЛА<select [(ngModel)]="Power1">
  <option value="5">5</option>
  <option value="10">10</option>
  <option value="20">20</option>
  <option value="25">25</option>
  <option value="30">30</option>
  <option value="40">40</option>
  <option value="50">50</option>
  <option value="80">80</option>
  <option value="100">100</option>
 </select>
 </label>

<label *ngIf="!isElevation">Подъем
    <input type="number" [(ngModel)]="Elevation1" />  
</label>

<label>Отклонение
    <input type="number" [(ngModel)]="Bearing" > 
</label>

<br>
<button (click)="calculateErrors()">
    Вычислить ошибки
</button>

<div *ngIf="hasResult">
  <p [style.background-color]="deltaBearing>=-10 && deltaBearing<=10 ? 'transparent' : 'red'" >ΔBearing: {{deltaBearing}}</p> 
  <p [style.background-color]="deltaElevation>=-25 && deltaElevation<=25 ? 'transparent' : 'red'" >ΔElevation: {{deltaElevation}}</p>
  <p [style.background-color]="deltaPower>=-4 && deltaPower<=0 ? 'transparent' : 'red'" >ΔPower: {{deltaPower}}</p>
</div>